import {
  getUserInfoTicket,
  getUserInfoToken,
  getUniscidByName,
  getUserRelationship,
  getUserDishonestyInfo,
  getToken
} from '@/api/user'
import { findCityInfoById } from '@/utils/findCityInfoById'
import { judgeShouldGoGrayEnv } from '@/features/user'

const state = {
  ticket: null,
  token: null,
  userType: '',
  isTokenExpire: false,
  userInfo: null,
  isDefaultCityInfoSet: false,
  cityInfo: {
    areaId: null,
    city: null,
    district: null
  },
  userTypeFromURL: '',
  ifmToken: '',
  uiStyle: 'normal',
  // 脱敏状态
  desensitizeStatus: false
}

const getters = {
  getCityDistrictId: state => {
    if (!state.cityInfo.city || !state.cityInfo.district) {
      return []
    }
    return [state.cityInfo.city.id, state.cityInfo.district.id]
  }

}

const mutations = {
  SET_USER_TICKET(state, ticket) {
    state.userType = '法人'
    state.ticket = ticket
    sessionStorage.setItem('USERTYPE', state.userType)
  },
  SET_USER_TOKEN(state, token) {
    state.userType = '个体工商户'
    state.token = token
    sessionStorage.setItem('USERTYPE', state.userType)
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  CLEAN_USER_INFO(state) {
    state.userInfo = null
    state.userType = null
    state.token = null
    state.ticket = null
  },
  SET_DEFAULT_CITY_INFO(state, info) {
    // 设定默认城市选中  通过标识判断是否已经设定过
    if (!state.isDefaultCityInfoSet) {
      state.cityInfo = JSON.parse(info)
      state.isDefaultCityInfoSet = true
    }
  },
  SET_CITY_INFO(state, info) {
    state.cityInfo = {
      ...state.cityInfo,
      ...info
    }
  },
  SET_IS_TOKEN_EXPIRE(state, isExpire) {
    state.isTokenExpire = isExpire
  },
  SET_USER_TYPE_FROM_URL(state, userType) {
    state.userTypeFromURL = userType
  },
  SET_IFM_TOKEN: (state, token) => {
    state.ifmToken = token
  },
  SET_IFM_UISTYLE: (state, uiStyle) => {
    state.uiStyle = uiStyle
  },
  SET_DESENSITIZE_STATUS: (state, desensitizeStatus) => {
    state.desensitizeStatus = desensitizeStatus
  }
}

const actions = {
  async getUserInfo({ dispatch, state }) {
    let data
    if (state.userType === '个体工商户') {
      data = await dispatch('getUserInfoToken')
    } else {
      data = await dispatch('getUserInfoTicket')
    }
    return data
  },
  async getUserInfoTicket({ commit }) {
    const response = await getUserInfoTicket()
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_USER_INFO', data)
      judgeShouldGoGrayEnv(data)
    }
    return data
  },
  async getUserInfoToken({ commit }) {
    const response = await getUserInfoToken()
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_USER_INFO', data)
      judgeShouldGoGrayEnv(data)
    }
    return data
  },
  async getMappingAreaId({ commit, dispatch, rootState }, payload) {
    const { areaId } = payload
    let { fullAreaList } = rootState.area
    if (!fullAreaList || fullAreaList.length === 0) {
      fullAreaList = await dispatch('area/getFullArea', {}, { root: true })
    }
    let [city, district] = findCityInfoById(areaId, fullAreaList)
    commit('SET_CITY_INFO', { city, district })
    return areaId
  },
  //   使用企业名称 获取 统一社会性用代码
  async getUniscidByName({ commit }, { name }) {
    const response = await getUniscidByName({ name })
    return response.data
  },
  //   获取企业关联关系
  async getUserRelationship({ commit }, { cardNo, uniscid }) {
    const response = await getUserRelationship({ cardNo, uniscid })
    return response.data
  },
  //   判断个人是否在黑名单内
  async getUserDishonestyInfo({ commit }, { cardId, name }) {
    let res
    try {
      res = await getUserDishonestyInfo({ cardId, name })
    } catch (err) {
      return 'error'
    }
    const { code, data } = res.data
    if (code === 4002) {
      await this.$store.dispatch('user/getUserToken')
      return data
    }
    if (code !== 0) return 'error'
    // data 为 true 时表示在黑名单
    return data
  },
  // token失效后重新获取
  async getUserToken({ commit }) {
    const res = await getToken()
    const { code, data } = res.data
    if (code === 0) {
      commit('SET_IFM_TOKEN', data)
      // window.location.reload()
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
